import React, { useEffect, useState } from "react";
import "./RecentBlog.css";
import footerimg from "../../../Component/Images/footerimg.png";
import imgg1 from "../../../Component/Images/imgggnew1.png";
import imgg2 from "../../../Component/Images/imgg2.png";
import imgg3 from "../../../Component/Images/imgg3.png";
import imgg4 from "../../../Component/Images/imgg4.png";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { environmentVariables } from "../../../config/env.config";
import { formatDate } from "../../../Component/DateFormat/DateFormat";
import authorimg from '../../../Component/Images/3.png';

const RecentBlog = ({ id }) => {
  // const [searchParams] = useSearchParams();
  //   const id = searchParams.get("id");
  const [blogPosts, setBlogPosts] = useState([]); // Ensure it's initialized as an array
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(
        `${environmentVariables?.apiUrlBlogs}api/v1/user/get-all-blogs`,
        { params: { type: 'be' } }
      );

      console.log("Full API Response:", response);

      if (response?.data?.statusCode === 200) {
        console.log("Blogs Data:", response.data.data);
        setBlogPosts(response.data.data || []); // Ensure it's an array
      } else {
        console.error("API Error:", response.data?.message);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  console.log("tanuj====",blogPosts,id)
  const filteredBlogs = blogPosts
  ?.filter((post) => post?.id != id) // Exclude the blog with the given id
  ?.slice(0, 4);

  return (
    <div className="RecentBlog">
      <h1>Recent Blog</h1>
      <div className="blog-container">
        {
          filteredBlogs?.length > 0 ? 
          filteredBlogs?.map((post,index)=>{
           return ( <div className="blog-card" key={index}>
            {/* Image section */}
            <div className="blog-image-container">
            <Link to={`/blog-page/${post?.slug}`} state={post?.id} > <img
                src={post?.image
                  ? `${environmentVariables?.apiUrlBlogs}uploads/files/${post.image}`
                  : authorimg}
                alt="Three people sitting at a table with laptops"
                className="blog-image"
              /> </Link> 
            </div>
  
            {/* Content section */}
            <div className="blog-content">
              {/* Author and date */}
              <div className="blog-footer">
                <p className="date">{formatDate(post?.created_at)}</p>
                {/* <div className="blog-stats">
                  <span className="stats-item">
                    <svg className="stats-icon" viewBox="0 0 24 24">
                      <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                    <p> 48 Views</p>
                  </span>
                  <span className="stats-item">
                    <svg className="stats-icon" viewBox="0 0 24 24">
                      <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                    </svg>
                    <p>10 Comments</p>
                  </span>
                </div> */}
              </div>
  
              {/* Title */}
              <h2 className="blog-title" dangerouslySetInnerHTML={{ __html: post?.heading }}>
              </h2>
              <p className="para" dangerouslySetInnerHTML={{ __html: post?.description }}>
              </p>
              {/* Footer with read more, views and comments */}
              <div className="blog-meta">
                <div className="imagee">
                  <img src={`${environmentVariables?.apiUrlBlogs}uploads/files/${post?.author?.profile_pic}` || footerimg} alt="error" />
                </div>
                <div className="textt">
                  <h4>{post?.author?.name}</h4>
                  <p>{post?.author?.tag}</p>
                </div>
              </div>
            </div>
          </div> )
          }):
        <div>No Blogs Available</div>
        }
        
        {/* <div className="blog-card">
          <div className="blog-image-container">
            <img
              src={imgg2}
              alt="Three people sitting at a table with laptops"
              className="blog-image"
            />
          </div>

          <div className="blog-content">
            <div className="blog-footer">
              <p className="date">16 Feb 2025</p>
              <div className="blog-stats">
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                  <p> 48 Views</p>
                </span>
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                  </svg>
                  <p>10 Comments</p>
                </span>
              </div>
            </div>

            <h2 className="blog-title">
              Why UI/UX Design is Crucial for Business Growth{" "}
            </h2>
            <p className="para">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum is simply dummy text of the printing and
              typesetting industry.
            </p>
            <div className="blog-meta">
              <div className="imagee">
                <img src={footerimg} alt="error" />
              </div>
              <div className="textt">
                <h4>By Jennifer Lawrence</h4>
                <p>Thinker & Designer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-image-container">
            <img
              src={imgg3}
              alt="Three people sitting at a table with laptops"
              className="blog-image"
            />
          </div>

          <div className="blog-content">
            <div className="blog-footer">
              <p className="date">16 Feb 2025</p>
              <div className="blog-stats">
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                  <p> 48 Views</p>
                </span>
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                  </svg>
                  <p>10 Comments</p>
                </span>
              </div>
            </div>

            <h2 className="blog-title">
              Why UI/UX Design is Crucial for Business Growth{" "}
            </h2>
            <p className="para">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum is simply dummy text of the printing and
              typesetting industry.
            </p>
            <div className="blog-meta">
              <div className="imagee">
                <img src={footerimg} alt="error" />
              </div>
              <div className="textt">
                <h4>By Jennifer Lawrence</h4>
                <p>Thinker & Designer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="blog-card">
          <div className="blog-image-container">
            <img
              src={imgg4}
              alt="Three people sitting at a table with laptops"
              className="blog-image"
            />
          </div>

          <div className="blog-content">
            <div className="blog-footer">
              <p className="date">16 Feb 2025</p>
              <div className="blog-stats">
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                  <p> 48 Views</p>
                </span>
                <span className="stats-item">
                  <svg className="stats-icon" viewBox="0 0 24 24">
                    <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                  </svg>
                  <p>10 Comments</p>
                </span>
              </div>
            </div>

            <h2 className="blog-title">
              Why UI/UX Design is Crucial for Business Growth{" "}
            </h2>
            <p className="para">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum is simply dummy text of the printing and
              typesetting industry.
            </p>
            <div className="blog-meta">
              <div className="imagee">
                <img src={footerimg} alt="error" />
              </div>
              <div className="textt">
                <h4>By Jennifer Lawrence</h4>
                <p>Thinker & Designer</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default RecentBlog;
